module.exports = __webpack_public_path__ + "static/media/Nathalie Cortez Front End (English).fa182dad.pdf";